import { LogIn, MonitorSmartphone } from "lucide-react";
import { XALTIX_CSS, Emblem } from "./XaltixWelcome";

export const SessionReplaced = ({ onDone }) => (
  <div className="xl fixed inset-0 z-[100] overflow-y-auto" data-testid="session-replaced-screen"
       style={{ background: "radial-gradient(900px circle at 50% 30%, #1A4BC0 0%, #0B2A7A 45%, #06184A 100%)" }}>
    <style>{XALTIX_CSS}</style>
    <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(400px circle at 50% 22%, rgba(246,216,138,.18), transparent 70%)" }} />
    <div className="relative min-h-full flex flex-col items-center justify-center text-center px-5 py-10">
      <div className="xl-zoom w-20 h-20 sm:w-32 sm:h-32"><Emblem className="w-full h-full" /></div>
      <p className="xl-in xl-h text-[11px] sm:text-xs text-[#F6D88A]/80 mt-6" style={{ animationDelay: ".35s" }}>XALTIX</p>
      <h1 className="xl-in text-3xl sm:text-5xl font-extrabold text-white mt-4 tracking-tight max-w-3xl" style={{ animationDelay: ".6s" }} data-testid="session-replaced-title">
        Vous avez été <span className="xl-gold">déconnecté</span>
      </h1>
      <div className="xl-in mt-6 max-w-xl rounded-2xl border border-white/15 bg-white/5 backdrop-blur-md px-6 py-5 flex items-start gap-4 text-left" style={{ animationDelay: ".95s" }}>
        <MonitorSmartphone className="h-6 w-6 text-[#F6D88A] shrink-0 mt-0.5" />
        <p className="text-sm sm:text-base text-[#C9D6F5] leading-relaxed" data-testid="session-replaced-message">
          Votre compte vient de se connecter sur un autre appareil ou un autre navigateur. Pour protéger votre compte, une seule session peut rester ouverte à la fois.
          <span className="block mt-2 text-[#C9D6F5]/70 text-xs sm:text-sm">Si ce n'était pas vous, reconnectez-vous puis changez votre mot de passe.</span>
        </p>
      </div>
      <button type="button" onClick={onDone} data-testid="session-replaced-login-btn" style={{ animationDelay: "1.3s" }}
        className="xl-in xl-btn inline-flex items-center gap-2 px-10 py-3.5 rounded-full mt-9 text-sm"><LogIn className="h-4 w-4" />Se reconnecter</button>
    </div>
  </div>
);
